export default __webpack_public_path__ + "a46d1e1cb82b5ae912f0c976d196f3e5.svg";